import { useCountryName } from '@/hooks'
import useRegion from '@/hooks/useRegion'

import styles from './style.module.scss'

interface DeliveryAddressProps {
  data: {
    country?: string
    name?: string
    name2?: string
    street?: string
    street4?: string
    houseNumber?: string
    zip?: string
    region?: string
    city?: string
    [key: string]: unknown
  }
  ignores?: string[]
}

export const DeliveryAddress = ({ data, ignores }: DeliveryAddressProps) => {
  const { getAddressWithRegion } = useRegion()
  const { country } = data
  const countryName = useCountryName(country)
  const { name, address, location, street4 } = getAddressWithRegion(
    data,
    ignores,
  )

  return (
    <div className={styles.deliveryAddress}>
      <strong>{name}</strong>
      <span>{address}</span>
      <span>{street4}</span>
      <span>{location}</span>
      <strong>{countryName}</strong>
    </div>
  )
}
